'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  TOP: null,
  BOTTOM: null,
  MIDDLE: null
}));